import { TranslationObject } from '@ngx-translate/core';

const pt: TranslationObject = {
  pt: 'Português',
  app: {
    test: 'Isto é uma etiqueta de teste',
    title: 'SWD - Disciplina de Trabalho',
    welcomeMessage: 'Bem-vindo ao aplicativo web SWD',
    forms: {
      ok: 'Ok',
      cancel: 'Cancelar',
      continue: 'Continuar',
      labels: {
        businessUnit: 'Unidade de Negócios',
        placeholderBusinessUnit: 'Selecione uma unidade de negócio',
        user: 'Usuário',
        name: 'Nome',
        description: 'Descrição',
        placeHolderDescription: 'Digite uma descrição',
        placeHolderReviewType: 'Selecione um tipo de revisão',
        mandatory: 'Obrigatório',
      },
      create: 'Criar',
      unsavedChangesWarning:
        'Alterações não salvas foram detectadas. Se você sair desta página, as modificações que você fez serão perdidas.<br>Você quer continuar?',
    },
    warnings: {
      removeOwnAdminRights:
        'Você removeu seus direitos de administrador. Por favor, atualize a página para evitar mau funcionamento.',

      removeOwnAccess: 'Você removeu seu acesso. Por favor, atualize a página para evitar mau funcionamento.',
    },
  },
  navigation: {
    startWorkDone: 'Observações',
    category: 'Categorias',
    businessUnits: 'Unidade de Negócios',
    sysAdmins: 'Administradores do Sistema',
    administration: 'Administração',
    users: 'Usuários',
    areas: 'Áreas',
    errorReductionTools: 'Ferramentas de redução de erros',
  },
  startWorkDoneList: {
    title: 'Observações',
    noStartWorkDone:
      'Selecione uma Unidade de Negócios, Área, Sub Área, Categoria e Pessoa Observada para exibir registros',
    emptyList: 'Nenhum registro de Disciplina de Trabalho encontrado para os filtros selecionados',
    id: 'ID',
    question: 'Controle',
    answer: 'Resposta',
    score: 'Pontuação',
    comment: 'Comentário',
    errorReductionTool: 'Ferramenta de redução de erros',
    updatedBy: 'Atualizado por',
    updatedDate: 'Data de Atualização',
    createNewStartWorkDone: 'criar novo trabalho inicial',
    reviewType: 'Tipo de Revisão',
    area: 'Área',
    observationDate: 'Data de Observação',
    subArea: 'Sub Área',
    category: 'Categoria',
    placeholderArea: 'Selecione uma área',
    placeholderSubArea: 'Selecione uma sub área',
    placeholderCategory: 'Selecione uma categoria',
    addQuestion: 'Adicionar Controle',
    description: 'Descrição',

    subSection: 'Subseção',
    clearAnswer: 'Limpar Resposta',
    deleteQuestion: 'Excluir Controle',
    deleteQuestionTitle: 'Excluir Controle',
    confirmDeleteQuestion:
      '<span>Tem certeza de que deseja excluir este controle?</span><br><br><span><b>Controle:</b> {{ description }}</span>',
    editQuestion: 'Editar Controle',
    editQuestionHeader: 'Editar Controle',
    userSearch: 'Pessoa Observada',
    userSearchPlaceholder: 'Pesquisar por nome ou email...',
    supervisor: 'Supervisor',
    noSupervisor: 'Nenhum supervisor encontrado',
    generateReport: 'Gerar Relatório',
    completeReview: 'Concluir e Enviar Relatório',
    generateReportInfoMessage:
      'Seu relatório está sendo gerado e será baixado automaticamente. Isso pode levar alguns instantes.',
    generateSuccessMessage: 'Relatório gerado com sucesso',
    reviewSuccessMessage: 'Relatório de observação SWD enviado com sucesso',
    sendEmail: 'Enviar Email',
    emailSuccessMessage: 'Email enviado com sucesso',
    emailErrorMessage: 'Erro ao enviar email',
    tableColumns: {
      businessUnit: 'Unidade de Negócios',
      category: 'Categoria',
      subArea: 'Sub Área',
      area: 'Área',
      user: 'Pessoa Observada',
      supervisor: 'Supervisor',
      observationDate: 'Data de Observação',
      totalScore: 'Pontuação Total',
      createdBy: 'Observador',
    },
    viewEdit: 'Ver / Editar',
  },
  startWorkDoneDetail: {
    title: 'Observação',
    details: 'Informações Gerais',
    notFound: 'Registro de disciplina de trabalho não encontrado',
    accessDenied: 'Você não tem acesso a esta observação.',
    saveSuccess: 'Registro atualizado com sucesso',
    editInfo: 'Editar Informações',
    saveInfo: 'Salvar Informações',
    errorReductionTools: 'Ferramentas de redução de erros',
    noControls: 'Nenhum controle encontrado. Adicione controles a esta categoria primeiro.',
    totalScore: 'Pontuação Total',
    deleteObservation: 'Excluir Observação',
    deleteConfirmTitle: 'Excluir Observação',
    deleteConfirmMessage: 'Tem certeza de que deseja excluir esta observação? Esta ação não pode ser desfeita.',
    deleteSuccess: 'Observação excluída com sucesso',
    noObservationDate:
      'Nenhuma Data de Observação foi selecionada. Por favor, selecione uma data antes de concluir esta revisão.',
  },
  categoryList: {
    title: 'Categorias',
  },
  admin: {
    sysAdminList: {
      title: 'Administradores do Sistema',
      addSysAdmin: 'adicionar administrador do sistema',
      fullName: 'nome completo',
      email: 'e-mail',
      dialogs: {
        removeAccessHeader: 'Confirmação',
        removeAccessMessage:
          'Tem certeza de que deseja remover o acesso de administrador do sistema para: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unidade de Negócios',
      addBusinessUnit: 'adicionar unidade de negócio',
      tableTitle: 'Unidade de Negócios',
      noBusinessUnits: 'Nenhuma unidade de negócios encontrada.',
      dialogs: {
        createHeader: 'Criar Unidade de Negócios',
        namePlaceholder: 'Insira um nome',
      },
    },
    businessUnitEdit: {
      title: 'Editar Unidade de Negócios',
    },
    errorReductionTools: {
      title: 'Ferramentas de redução de erros',
      addErt: 'adicionar ferramenta de redução de erros',
      tableTitle: 'ferramenta de redução de erros',
      noErts: 'Nenhuma ferramenta de redução de erros encontrada.',
      dialogs: {
        createHeader: 'Criar ferramenta de redução de erros',
        editHeader: 'Editar ferramenta de redução de erros',
        namePlaceholder: 'Insira um nome',
        deleteTitle: 'Excluir ferramenta de redução de erros',
        deleteMessage: 'Tem certeza de que deseja excluir a ferramenta de redução de erros <strong>{{name}}</strong>?',
        deleteSuccess: 'Ferramenta de redução de erros excluída com sucesso.',
        deleteConflict:
          'Esta ferramenta de redução de erros não pode ser excluída porque está associada a um ou mais controles.',
      },
    },
    areas: {
      title: 'Áreas',
      areasTitle: 'Áreas',
      subAreasTitle: 'Sub Áreas',
      addArea: 'Adicionar Área',
      addSubArea: 'Adicionar Sub Área',
      areaName: 'Nome',
      subAreaName: 'Sub Áreas',
      category: 'Categoria',
      noAreas: 'Nenhuma área disponível.',
      noSubAreas: 'Nenhuma sub área disponível.',
      selectAreaMessage: 'Selecione uma área para gerenciar suas sub áreas.',
      dialogs: {
        createAreaHeader: 'Criar Área',
        editAreaHeader: 'Editar Área',
        createSubAreaHeader: 'Criar Sub Área',
        editSubAreaHeader: 'Editar Sub Área',
        namePlaceholder: 'Insira um nome',
        category: 'Categoria',
        categoryPlaceholder: 'Selecione uma categoria (opcional)',
        deleteAreaTitle: 'Excluir Área',
        deleteAreaMessage: 'Tem certeza de que deseja excluir a área <strong>{{name}}</strong>?',
        deleteAreaLinkedRecords:
          'Não é possível excluir esta área porque ela possui registros de Disciplina de Trabalho vinculados.',
        deleteSubAreaTitle: 'Excluir Sub Área',
        deleteSubAreaMessage: 'Tem certeza de que deseja excluir a sub área <strong>{{name}}</strong>?',
        deleteSubAreaLinkedRecords:
          'Não é possível excluir esta sub área porque ela possui registros de Disciplina de Trabalho vinculados.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Não registrado',
      forms: {
        submit: 'Solicitar acesso',
      },
      dialogTitle: 'Solicitar acesso',
      dialogSubtitle: 'Você está prestes a solicitar acesso para <strong>{{name}}</strong>',
      reloadWarning:
        'Se você visitar esta página mas já tiver acesso, clique no link a seguir para recarregar; caso contrário, entre em contato com o suporte.',
      reload: 'Recarregar',
    },
    pendingAccess: {
      title: 'Olá, sua solicitação de acesso está em andamento',
      reloadWarning:
        'Se você visitar esta página mas já tiver acesso, clique no link a seguir para recarregar; caso contrário, entre em contato com o suporte.',
      reload: 'Recarregar',
    },
  },
  header: {
    logoAlt: 'Logotipo da CVX',
    userAvatarAlt: 'Avatar do usuário',
    unknownUser: 'Desconhecido',
  },
  footer: {
    text: 'Chevron Corporation. Todos os direitos reservados.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Categorias',
    create: 'Criar',
    name: 'Nome',
    description: 'Descrição',
    actions: 'Ações',
    edit: 'Edit',
    manage: 'Gerenciar',
    delete: 'Excluir',
    confirmDelete:
      '<span>¿Tem certeza de que deseja excluir esta categoria?</span><br><br><span>Nome: {{ name }}<br>Descrição: {{ description }}</span>',
    noCategories: 'Nenhuma categoria disponível.',
    titleCreate: 'Criar categoria',
    createNew: 'Criar novo',
    selectPlaceholder: 'Selecione uma opção...',
    titleEdit: 'Editar categoria',
    titleDelete: 'Excluir categoria',
    deletedSuccessfully: 'Categoria excluída com sucesso',
    importCategory: 'Importar categoria',
    importCategoryTitle: 'Importar categoria para ',
    selectCategoryType: 'Selecionar tipo de categoria',
    confirm: 'Confirmar',
    importSuccessMessage: 'Categoria importada com sucesso',
    manageControls: 'Gerenciar Controles',
    noControls: 'Nenhum controle disponível.',
    selectBusinessUnit: 'Selecione uma unidade de negócio para exibir os controles',
    importCategoriesTitle: 'Importar Categorias',
    import: 'Importar',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Salvar',
    businessUnit: 'Unidade de Negócio',
    forbidActionErrorMessage: 'O usuário não está autorizado a realizar esta ação',
    name: 'Nome',
    code: 'Código',
    cancel: 'Cancelar',
    genericErrorMessage: 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.',
    savedSuccessfully: 'Salvo com sucesso',
    delete: 'Excluir',
    deletedSuccessfully: 'Excluído com sucesso',
    edit: 'Editar',
    leaveWithOutSaving: 'Sair sem salvar',
    language: 'Idioma',
    view: 'Ver',
    back: 'Voltar',
    createdBy: 'Criado por',
    updatedBy: 'Atualizado por',
    updatedDate: 'Data de Atualização',
    errors: {
      failedToSubmit: 'Falha ao enviar a resposta. Por favor, tente novamente.',
    },
  },
  serverError: {
    title: 'Servidor indisponível',
    message: 'Não foi possível conectar ao servidor. Verifique sua conexão de rede ou tente novamente mais tarde.',
    returnHome: 'Voltar ao início',
  },
  pageNotFound: {
    title: 'Página não encontrada',
    message: 'A página que você está procurando não existe.',
    returnHome: 'Voltar ao início',
  },
  unauthorized: {
    title: 'Acesso não autorizado',
    message: 'Você não tem permissão para acessar esta página.',
    returnHome: 'Voltar ao início',
  },
  categoryManage: {
    title: 'Gerenciar conteúdo de [{{ description }}]',
    questionsTitle: 'Controles',
    addQuestionAction: 'adicionar controle',
    questionName: 'Controle',
    questionNamePlaceholder: 'Insira o texto do controle',
    errorReductionTools: 'Ferramentas de redução de erros',
    ertPlaceholder: 'Selecione ferramentas de redução de erros',
    noQuestions: 'Nenhum controle encontrado. Adicione um controle para começar.',
    sectionsTitle: 'Sessões',
    subSectionsTitle: 'Subseções',
    addSectionAction: 'adicionar seção',
    mandatoryLabel: 'Obrigatório',
    createNewSubsectionAction: 'adicionar grupo de controles',
    emptySubSectionsMessage: `<p>Não há conteúdo disponível para esta seção.</p>
      <p>Por favor, adicione uma subseção para começar.</p>`,
    itemDescriptionTableHeader: 'Descrição',
    createNewItemAction: 'Adicionar controle',
    createSectionHeader: 'Criar Seção',
    editSectionHeader: 'Editar Seção',
    confirmDeleteSection: 'Tem certeza de que deseja excluir a seção <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Adicionar grupo de controles',
    editSubSectionHeader: 'Editar subseção',
    createQuestionTitle: 'Criar Controle',
    ShouldAddCommentToQuestion: 'O usuário deve adicionar um comentário a qualquer controle respondido com N/A',
    deleteQuestionTitle: 'Excluir Controle',
    confirmDeleteQuestion:
      '<span>Tem certeza de que deseja excluir este controle?</span><br><br><span><b>Descrição:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Tem certeza de que deseja excluir a subseção <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Excluir seção',
    deleteSubSectionHeader: 'Excluir subseção',
    editQuestionTitle: 'Editar Controle',
    defaultSubSectionName: 'Controles',
  },
  paginator: {
    previous: 'Anterior',
    next: 'Próximo',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} de {{totalRecords}}',
  },
  usersList: {
    title: 'Usuários',
    forms: {
      displayInactiveUsers: 'exibir usuários inativos',
    },
    actions: {
      addNewUser: 'Adicionar novo usuário',
      grantAccess: 'conceder acesso',
    },
    table: {
      fullName: 'nome completo',
      email: 'e-mail',
      admin: 'admin',
    },
    noUsers: 'Nenhum usuário disponível',

    dialogs: {
      removeAccessHeader: 'Confirmação',
      removeAccessMessage: 'Tem certeza de que deseja remover o acesso para: [{{fullName}}]?',
    },
  },
  actionItems: {
    title: 'Itens de Ação',
    addActionItem: 'adicionar item de ação',
    actionTitle: 'Título',
    assignee: 'Responsável',
    date: 'Data',
    id: 'ID',
    comment: 'Comentário',
    priority: 'Prioridade',
    dialogs: {
      configureActionItem: 'Configurar Item de Ação',
      configureComment: 'Comentário',
      deleteActionItemHeader: 'Excluir item de ação',
      deleteActionItemMessage: 'Tem certeza de que deseja realizar esta ação?',
    },
  },
  comments: {
    title: 'Comentários',
    addComment: 'adicionar comentário',
    noComments: 'Sem comentários',
    dialogs: {
      configureComment: 'Comentário',
      deleteCommentHeader: 'Excluir Comentário',
      deleteCommentMessage: 'Tem certeza de que deseja realizar esta ação?',
    },
    comment: 'Comentário',
    instructions: {
      title: 'Os comentários devem incluir:',
      observed: 'O que foi observado',
      coaching: 'Qual coaching foi fornecido',
      action: 'Que ação foi tomada para resolver problemas',
      feedback: 'Qual feedback positivo foi dado por exceder expectativas',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Comentário da Observação',
      },
      placeholders: {
        enterComment: 'Digite seu feedback de coaching ou contexto para esta resposta...',
      },
      messages: {
        responseSubmitted: 'Resposta enviada com sucesso',
        commentRequired: 'Um comentário é necessário para este tipo de resposta',
      },
      responseAnswers: {
        noAttempt: 'Sem Tentativa',
        needsImprovement: 'Precisa de Melhoria',
        meetsExpectations: 'Atende às Expectativas',
        exceedsExpectations: 'Supera as Expectativas',
        notApplicable: 'Não Aplicável',
      },
    },
  },
};
export default pt;
